import { SuperBlocks } from '../../../config/certification-settings';

export function isFundamentosDaProgramacaoFrontEndCert(
  superBlock: string
): boolean {
  return superBlock === SuperBlocks.FundamentoDaProgramacaoFrontEnd;
}

export function isLogicaDeProgramacaoCert(superBlock: string): boolean {
  return superBlock === SuperBlocks.LogicaDeProgramacao;
}

export function isHtmlCssJavascriptCert(superBlock: string): boolean {
  return superBlock === SuperBlocks.HtmlCssJavascript;
}

export function isReactCert(superBlock: string): boolean {
  return superBlock === SuperBlocks.React;
}

export function isSourceAvailableCert(source: string): boolean {
  const certificationSources = ['pagantes', 'pagantes-modular'];
  return certificationSources.includes(source);
}
